import AutocompleteAsyncFormik from "@/common/components/form/AutoCompleteRenderAsyncFormik";
import { getPurchaseOrderById, searchPurchaseOrderByName } from "@/common/services/purchaseOrder.api";
import { Modal } from "flowbite-react"
import { Form, FormikProvider, useFormik } from "formik";
import { useEffect, useState } from "react";

import "./index.scss"
import { IPurchaseOrder, IPurchaseOrderItem } from "@/types/purchaseOrder.types";
import { GenericInfoField } from "@/common/helpers/generic-info-field";
import ModalPurchaseReturnInfo from "./Modal-return-info";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";

interface Props {
  opened: boolean
  onClose: () => void
}

type Option = {
  value: string;
  label: string;
};

export default function ModalCreatePurchaseReturn({ opened, onClose }: Props) {

  const [options, setOptions] = useState<Option[]>([]);
  const [purchaseSelected, setPurchaseSelected] = useState<IPurchaseOrder>();
  const [itensSelected, setItensSelected] = useState<IPurchaseOrderItem[]>([]);
  const [showModal, setShowModal] = useState(false);

  async function fetchPurchases(search: string) {
    const response = await searchPurchaseOrderByName(search);
    const options = response.data.map(purchase => ({ label: `OC: ${purchase.code} ${purchase.description}`, value: purchase._id as string }));
    setOptions(options);
    return options;
  }

  useEffect(() => {
    async function loadPurchases() {
      const data = (await searchPurchaseOrderByName('')).data;
      setOptions(data.map(purchase => ({ label: `OC: ${purchase.code} ${purchase.description}`, value: purchase._id as string })));
    }
    loadPurchases()
  }, []);

  const formik = useFormik({
    initialValues: {
      code: '',
      description: '',
      quantity: 0,
      reason: '',
      purchaseOrder: '',
      autoService: false,
    },
    onSubmit: () => {
    },
  });

  return (
    opened && <Modal show={opened} onClose={onClose}>
      <Modal.Header>
        Nova Devolução de Compra
      </Modal.Header>
      <Modal.Body className="modal-body-large">
        <FormikProvider
          value={formik}
        >
          <Form>
            <AutocompleteAsyncFormik
              loadOptions={fetchPurchases}
              label="Descrição do item, código da OC"
              name="purchaseSelected"
              onChange={async (option) => {

                // clear selection when changes purchase order
                setItensSelected([]);
                const purchase = await getPurchaseOrderById(option?.value || '');
                purchase.data.itens.map((_, index) => {
                  formik.setFieldValue(`item${index}`, false);
                });

                setPurchaseSelected(purchase.data);
              }}
              options={
                options.length > 0
                  ? options
                  : [{ value: '', label: '' }]
              }></AutocompleteAsyncFormik>

            <GenericInfoField spanSize={10} label="Solicitante" value={purchaseSelected?.requestorName} id="requestorName"></GenericInfoField>
            <GenericInfoField spanSize={10} label="Data de Criação OC" value={new Date(purchaseSelected?.createdAt as Date)?.toLocaleDateString("pt-BR")} id="requestorName"></GenericInfoField>


            <div className="border-b mb-6 pb-4">
              <h2 className="text-lg font-semibold mb-2">Itens da Ordem de Compra</h2>
              {purchaseSelected?.itens?.length && (
                <div className="overflow-auto">
                  <table className="min-w-full divide-y divide-gray-200 border rounded-md">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="px-4  py-2 text-left text-sm font-semibold text-gray-700">Descrição</th>
                        <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Qtd.</th>
                        <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Preço de Custo</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-100">
                      {purchaseSelected.itens.map((item, index) => (
                        <tr key={item._id || index} className="hover:bg-gray-50">
                          <p className="px-4 py-2 text-gray-900 max-w-[350px] truncate">{item.description}</p>
                          <td className="px-4 py-2 text-sm text-gray-900">{item.qtd}</td>
                          <td className="px-4 py-2 text-sm text-gray-900">{item.value}</td>
                          <div className="flex items-center gap-2 mt-4 mb-4">
                            <input
                              type="checkbox"
                              id="autoService"
                              name="autoService"
                              checked={formik.values[`item${index}`]}
                              onChange={e => {
                                formik.setFieldValue(`item${index}`, e.target.checked);
                                setItensSelected(prev => e.target.checked ? [...prev, item] : prev.filter(el => el._id !== item._id));
                              }}
                              className="h-4 w-4 accent-red-600"
                            />
                            <label htmlFor="autoService" className="text-sm font-bold text-red-600">
                              Devolver Item
                            </label>
                          </div>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </Form>
        </FormikProvider>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex justify-center">
          <ButtonWithLoader onClick={() => setShowModal(true)} className="bg-red-500 text-white px-4 py-2 rounded" disabled={itensSelected.length === 0}>
            Solicitar Devolução
          </ButtonWithLoader>
        </div>
      </Modal.Footer>
      {showModal && <ModalPurchaseReturnInfo purchaseOrderDescription={`OC ${purchaseSelected?.code} ${purchaseSelected?.description}`} purchaseOrderId={purchaseSelected?._id as string} itensSelected={itensSelected} onClose={() => { setShowModal(!showModal); onClose() }} opened={showModal}></ModalPurchaseReturnInfo>}
    </Modal>
  )
}
